// extracted by mini-css-extract-plugin
export default {"errorIconContainer":"src-components-Modules-revamp-Images-css-module__errorIconContainer--4+L3b","editIcon":"src-components-Modules-revamp-Images-css-module__editIcon--iToQX"};